// Modules
import styled from 'styled-components';

// Styles
import { BodyBoldTwo, Body } from '../../styles/common/typo.styles';

// Types
import { styledComponentProps } from '../../types/theme';

export const Content = styled.div`
	padding: 0 30px;
	margin-bottom: 30px;
	flex: 1;
	@media ${({ theme }: styledComponentProps): string => theme.breakpoints.lg} {
		flex: 1;
		width: 100%;
	}
	text-align: ${props => props.dir === 'ltr' ? 'left' : 'right'};
	* {
		text-align: ${props => props.dir === 'ltr' ? 'left' : 'right'}!important;
	}
`;

export const PBold = styled(BodyBoldTwo)`
	color: ${({ theme }: styledComponentProps): string =>
		theme.colors.ui.barIlanGreen};
`;

export const P = styled(Body)<any>`
	color: ${({ theme }: styledComponentProps): string =>
		theme.colors.ui.darkForestGreen};

	a {
		color: ${({ theme }: styledComponentProps): string =>
			theme.colors.ui.jungleGreen};
		text-decoration: underline;
		cursor: pointer;
	}

	p {
		font-size: 16px;
		font-weight: normal;
		font-stretch: normal;
		font-style: normal;
		line-height: 1.5;
		letter-spacing: normal;
		text-align: right;
		color: #003535;
	}

	p[dir="ltr"] {
		text-align: left;
	}
`;

export const Link = styled.a<any>`
	color: ${({ theme }: styledComponentProps): string =>
		theme.colors.ui.jungleGreen};
	margin: 0 0 23px;
	text-decoration: underline;
	cursor: pointer;
`;
